<template>
  <div>
    <template v-for="(item, id) in visibleItems">
      <slot name="item" v-bind:item="item">
        <p>{{item}}</p>
      </slot>
    </template>

    <slot name="collapsed-indicator" v-if="hasMoreItemToShow && isCollapsed">...</slot>

    <button class="gui-btn gui-btn--link"
            @click.prevent="isCollapsed = !isCollapsed"
            v-if="hasMoreItemToShow">
      {{$t(this.isCollapsed ? 'buttons.expand' : 'buttons.collapse')}}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array,
        default: []
      },

      limit: {
        type: Number,
        default: 5
      }
    },

    data: () => ({
      isCollapsed: true
    }),

    computed: {
      visibleItems() {
        if (this.isCollapsed && this.hasMoreItemToShow) {
          return this.value.slice(0, this.limit)
        }

        return this.value;
      },

      hasMoreItemToShow() {
        return this.value.length > this.limit;
      }
    }
  }
</script>

<style scoped>

</style>
